import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Button from '../../components/Button'
import Grid from '../../components/Grid'
import Header from '../../components/Header'
import SectionHeader from '../../components/SectionHeader'
import CheckLoginStatus from '../../conditions/CheckLoginStatus'
import WithPatient from '../../conditions/WithPatient'
import EditPatientLayout from '../../layouts/EditPatientLayout'
import ImageForm from './ImageForm'
import IndexesForm from './IndexesForm'
import MedicationList from './MedicationList'
import MedicationModal from './MedicationModal'
import ProfileForm from './ProfileForm'
import RemovePatient from './RemovePatient'
import SurgeriesForm from './SurgeriesForm'
import styled from 'styled-components'
import OCTForm from './OCTForm'
import ScreeningReasonForm from './ScreeningReasonForm'
import patient from '../../stores/patient'

const Row = styled.div`
  display: flex;
  width: 100%;
`

const Cell = styled.div`
  flex: 1;
  margin: 0 0.25rem;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
`

@observer
export default class EditPatient extends Component {
  @observable medicationModalOpen = false

  @action
  toggleMedicationModal = () => {
    this.medicationModalOpen = !this.medicationModalOpen
  }

  render() {
    const { match } = this.props
    const { patientID } = match.params
    const isCombat = patient.isCombat
    const diagnosisAgeQuery = patient.fields && patient.fields.diagnosisAge
      ? `?diagnosisAge=${encodeURIComponent(patient.fields.diagnosisAge)}`
      : ''

    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <WithPatient patientID={patientID}>
          {this.medicationModalOpen &&
            <MedicationModal onClose={this.toggleMedicationModal} />
          }
          <EditPatientLayout
            title="titles.editPatient"
          >
            <Row>
              <Cell>
                <Button color="green" str="titles.screening" to={`${isCombat? '/combat-screening': '/screening'}/${patientID}`} newWindow={true} onClick={patient.flushUpdate} />
              </Cell>
              <Cell>
                <Button color="blue" str="titles.adherence" to={`/adherence-stats/${patientID}`} newWindow={true} onClick={patient.flushUpdate} />
              </Cell>
            </Row>
            {!isCombat && <React.Fragment>
              <SectionHeader icon="fas fa-user-friends" color="dark-blue" str="titles.startSession" />
              <Row>
                <Cell>
                  <Button color="green" str="titles.session1" to={`/learn/first/${patientID}`} newWindow={true} onClick={patient.flushUpdate} />
                </Cell>
                <Cell>
                  <Button color="blue" str="titles.session2" to={`/goal/second/${patientID}${diagnosisAgeQuery}`} newWindow={true} onClick={patient.flushUpdate} />
                </Cell>
                <Cell>
                  <Button color="purple" str="titles.session3" to={`/session-intro/third/${patientID}`} newWindow={true} onClick={patient.flushUpdate} />
                </Cell>
                <Cell>
                  <Button color="gray" str="titles.phoneSession" to={`/phone-session/${patientID}`} newWindow={true} onClick={patient.flushUpdate} />
                </Cell>
              </Row>
            </React.Fragment>}
            <SectionHeader icon="fas fa-user" color="dark-blue" str="titles.patientProfile" />
            <ProfileForm />
            {/* {patient.fields && patient.fields.diagnosis === "SUSPECT" && */}
              <ScreeningReasonForm />
            {/* } */}
            <SectionHeader icon="fas fa-circle" color="dark-blue" str="titles.octResults" />
            <OCTForm />
            <SectionHeader icon="far fa-eye" color="dark-blue" str="titles.visualFieldIndexes" />
            <IndexesForm />
            <SectionHeader icon="fas fa-notes-medical" color="dark-blue" str="titles.surgeries" />
            <SurgeriesForm />
            <SectionHeader icon="fas fa-eye-dropper" color="dark-blue" str="titles.medications" />
            <MedicationList onAddMedication={this.toggleMedicationModal} />
            <SectionHeader icon="fas fa-camera" color="dark-blue" str="titles.images" />
            <Header color="dark-blue" str="titles.rightEye" />
            <Grid>
              <Grid.HalfCell>
                <ImageForm image="rightOpticNerve" header="titles.rightOpticNerve" />
              </Grid.HalfCell>
              <Grid.HalfCell>
                <ImageForm image="rightRecentField" header="titles.rightRecentField" />
              </Grid.HalfCell>
              <Grid.HalfCell>
                <ImageForm image="rightPreviousField" header="titles.rightPreviousField" />
              </Grid.HalfCell>
              <Grid.HalfCell>
                <ImageForm image="rightBaselineField" header="titles.rightBaselineField" />
              </Grid.HalfCell>
            </Grid>
            <Header color="dark-blue" str="titles.leftEye" />
            <Grid>
              <Grid.HalfCell>
                <ImageForm image="leftOpticNerve" header="titles.leftOpticNerve" />
              </Grid.HalfCell>
              <Grid.HalfCell>
                <ImageForm image="leftRecentField" header="titles.leftRecentField" />
              </Grid.HalfCell>
              <Grid.HalfCell>
                <ImageForm image="leftPreviousField" header="titles.leftPreviousField" />
              </Grid.HalfCell>
              <Grid.HalfCell>
                <ImageForm image="leftBaselineField" header="titles.leftBaselineField" />
              </Grid.HalfCell>
            </Grid>
            <RemovePatient />
          </EditPatientLayout>
        </WithPatient>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/EditPatient/index.js